import { EndPointService } from 'src/services/api-handlers/axios';

const ROUTE = 'dashboard';

const getStats = (params?: { year?: number }) => EndPointService.get(`/${ROUTE}/stats`, params);

export default {
    getStats,
};
